import { render, staticRenderFns } from "./ReceiverInfo.vue?vue&type=template&id=2728129f&scoped=true&"
import script from "./ReceiverInfo.vue?vue&type=script&lang=js&"
export * from "./ReceiverInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverInfo.vue?vue&type=style&index=0&id=2728129f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2728129f",
  null
  
)

export default component.exports